import React from 'react'
import styled from 'styled-components'
import theme from 'src/theme'
import { Bookmark, ExclamationTriangle, InfoCircle } from '@primer-io/goat-icons'
import { Icon } from '@primer-io/goat'

export const Root = styled.div`
	padding: 24px;
	display: grid;
	grid-template-columns: 24px 1fr;
	gap: 12px;
	border-radius: 6px;
	background: ${p => p.bg};
	justify-items: start;
	align-items: start;
`

const Content = styled.div`
	width: 100%;
	min-width: 0;

	line-height: 24px;

	& > *:first-child {
		padding-top: 0px;
		margin-top: 0px;
	}
`

const Emoji = styled.span`
  // The "Inter" font-family has issues with rendering number emojis in Chrome
	font-family: sans-serif;
`

/*
icon?: string
variant: info | neutral | danger
 */

export default function Callout(props) {
	const { icon: externalIcon, variant = 'info', emoji, children } = props

	const iconColor = {
		info: theme.colors.light.blue,
		neutral: theme.colors.light.black,
		danger: theme.colors.light.red,
	}[variant]

	const bgColor = {
		info: theme.colors.light.lightBlue,
		neutral: theme.colors.light.background,
		danger: theme.colors.light.lightRed,
	}[variant]

	const icon =
		externalIcon ??
		{
			info: InfoCircle,
			neutral: Bookmark,
			danger: ExclamationTriangle,
		}[variant]

	return (
		<Root bg={bgColor}>
			{emoji && <Emoji>{emoji}</Emoji>}
			{!emoji && <Icon as={icon} size={24} color={iconColor} />}
			<Content>{children}</Content>
		</Root>
	)
}
